import React, { useMemo, useState, useRef } from 'react'
import PropTypes from 'prop-types'

import { decode } from '@aytm/app/insights/dashboard/lib/sanitize'

const CLASS = 'insights-portal-editor-input'

const integerExpression = /^[+-]?\d+$/
const floatExpression = /^[+-]?(\d+([,.]\d*)?|[,.]\d+)$/

const parseText = source => {
  const number = parseFloat(source)
  return isNaN(number) ? null : number
}

const formatNumber = (source, accuracy) => (null === source ? '' : source.toFixed(accuracy))

const validateInput = (source, min, max, accuracy) => {
  if ('' === source.trim()) {
    return [true, null]
  } else {
    const expression = accuracy > 0 ? floatExpression : integerExpression
    if (expression.test(source)) {
      const number = parseFloat(source)
      if (number < min || number > max) {
        return [false, number]
      } else {
        const presision = source.replace(',', '.').split('.')[1]?.length || 0
        return presision > accuracy ? [false, number] : [true, number]
      }
    } else {
      return [false, null]
    }
  }
}

const NumberEditor = props => {
  const className = `${CLASS}${props.className ? ` ${props.className}` : ''}`

  const focused = useRef(false)

  const [min, max, accuracy] = useMemo(
    () => [props.min, props.max, props.accuracy >= 0 ? props.accuracy : 2],
    [props.min, props.max, props.accuracy]
  )

  const [value, setValue] = useState(null)
  const [text, setText] = useState('')

  const parcedValue = useMemo(() => parseText(props.value), [props.value])
  if (value !== parcedValue && !focused.current) {
    setText(formatNumber(parcedValue, accuracy))
    setValue(parcedValue)
  }

  const handleTextChange = event => {
    const input = event.target.value
    const [valid, number] = validateInput(input, min, max, accuracy)
    if (!valid) {
      event.preventDefault()
    } else {
      setText(input)
      setValue(number)
      props.onChange?.({ value: number })
    }
  }
  const handleFocus = () => {
    focused.current = true
  }

  const handleBlur = () => {
    focused.current = false
    setText(formatNumber(value, accuracy))
  }

  return (
    <input
      id={props.id}
      type={'text'}
      className={className}
      value={text}
      placeholder={decode(props.placeholder)}
      // eslint-disable-next-line react/no-unknown-property
      tooltip={null}
      autoComplete="off"
      onChange={handleTextChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onKeyDown={props.onKeyDown}
    />
  )
}

NumberEditor.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  id: PropTypes.string,
  accuracy: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.any,
  type: PropTypes.string,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func
}

NumberEditor.defaultProps = {
  min: 0,
  max: 100,
  accuracy: 2
}

export default NumberEditor
